import { burgerMenuReducerPath } from './const';
import { BurgerMenuSliceShape } from './types';

export const burgerMenuStateSelector = (state: BurgerMenuSliceShape) => state[burgerMenuReducerPath];
